<template>
  <div class="intelligentAgriculture-page">
    <!-- 乡村资源一张图 -->
    <div class="haeder-container blackStatic" style="height:141px;">
        <Header></Header>
        <Nav></Nav>
    </div>
    	<div class="main text-img-box">
			<div class="top-banner" style="position: relative;">
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/xiaojinxian/xjxbg.jpg">            
            </div>
            <div style="background:#F4F9EF;text-align: center;padding: 60px;height:240px;position: relative;">
                <div class="wuzhen-title">
                    <img style="width:200px;height:auto;margin:auto;" src="../../assets/img/caseDetails/wuzhen/wuzhentitle.png">
                </div>
                <div style="width: 650px;
                    margin: auto;
                    background: #fff;
                    text-align: justify;
                    padding: 40px;
                    line-height: 31px;
                    color: #333;
                    position: absolute;
                    left: 50%;
                    margin-left: -325px;
                    bottom:-100px;">
                    <p>项目包含建立四情监测系统、建设数字果园作物监测平台，实现果园作物生产过程监测、建设视频安防监控平台，实现农作物生产环境视频监控、水肥一体化建设、建立产业大数据大屏系统，实现可视化信息管理、全产业链服务一体化建设。</p>
                </div>
            </div>		
            <div class="inside-box" style="padding-top:100px;">
                <div class="inside-nav">
                    <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                        <img style="float:right;" src="../../assets/img/index/arrow.png">
                    </div>                       
                    <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">小金县沃日镇乡村振兴农文旅融合一体化建设</span>
                </div>
                <div class="img-box">
                    <img style="width:100%;height:auto;margin:auto;" src="../../assets/img/caseDetails/xiaojinxian/xjx1.jpg">
                </div>   
            </div>
            <div class="inside-box" style="padding-top:20px;">
                <div class="inside-nav">
                    <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                        <img style="float:right;" src="../../assets/img/index/arrow.png">
                    </div>                       
                    <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">小金县沃日镇智慧农业建设项目</span>
                </div>
                <div class="img-box">
                    <img style="width:100%;height:auto;margin:auto;" src="../../assets/img/caseDetails/xiaojinxian/xjx2.png">
                </div>   
            </div>
            <div class="inside-box" style="padding-top:20px;">
                <div class="inside-nav">
                    <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                        <img style="float:right;" src="../../assets/img/index/arrow.png">
                    </div>                       
                    <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">高效节水灌溉建设</span>
                </div>
                <div class="img-box">
                    <div style="width:43%;float:left;margin-right:6%">
                        <img style="width:100%;height:345px;margin:auto;" src="../../assets/img/caseDetails/xiaojinxian/xjx3.jpg">
                        <a style="width:100%;display:block;text-align:center;margin-top: 20px;">高效节水灌溉区</a>
                    </div>  
                    <div style="width:43%;float:right">
                        <img style="width:100%;height:345px;margin:auto;" src="../../assets/img/caseDetails/xiaojinxian/xjx4.jpg">
                        <a style="width:100%;display:block;text-align:center;margin-top: 20px;">高效节水灌溉-蓄水池</a>
                    </div>  
                </div>   
            </div>
            <div style="background:#F7FAEF;padding-top:20px;padding-bottom:20px;" >
                <div class="inside-box" style="padding-top:20px;">
                    <div class="inside-nav">
                        <div class="green-nav" style=" background: #289959;width: 34px;float:left;margin-right: 14px;">
                            <img style="float:right;" src="../../assets/img/index/arrow.png">
                        </div>                       
                        <span style="float: left;font-size: 24px;font-weight: 700;line-height: 30px;">现代农业苹果基地</span>
                    </div>
                    <div class="img-box">
                        <img style="width:100%;height:auto;margin:auto;" src="../../assets/img/caseDetails/xiaojinxian/xjx5.png">
                    </div>   
                </div>
            </div>
		</div>
        
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style>
.inside-box{
    width: 1200px;
    margin: auto;
    margin-bottom: 40px;
}
.img-box{
    width: 100%;
}
.inside-nav{
    margin-bottom: 15px;
}
 .haeder-container {
	width: 100%;
	height: 129px;
	margin: 0 auto;
	background-color: #030512;
}

div:after,
li:after,
ul:after {
	clear: both;
	content: "";
	width: 0;
	height: 0;
	display: block;
	visibility: hidden;
}

*{
    margin:0;
    padding:0;
}
html, body, div, span, object, iframe,h1, h2, 
h3, h4, h5, h6, p, blockquote, pre,abbr, address, cite, code,del, dfn, 
em, img, ins,kbd, q, samp,small, strong, sub, sup, var,b, i,dl, dt, dd, 
ol, ul, li,fieldset, form, label, legend,table, caption, tbody, 
tfoot,thead,tr, th, td,article, aside, canvas, details, figcaption, 
figure, footer, header, hgroup, menu, nav, section, summary,time, mark, 
audio, video {
    margin:0;
    padding:0;
    border:0;
    outline:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    outline-style:none;
}
 
body {
    line-height:1;
}
ol, ul{
    text-decoration: none;
    list-style: none;
}
a{
    margin:0;
    padding:0;
    border:0;
    font-size:100%;
    vertical-align:baseline;
    background:transparent;
    text-decoration:none;
    outline-style:none;
}
a:hover,a:focus{
    text-decoration:none;
    outline-style:none;
    }
table {
    border-collapse:collapse;
    border-spacing:0;
}
input, select {
    vertical-align:middle;
}
.clear{
    clear: both;
}








@media all and (max-width: 1400px) and (min-width: 820px) {
	.main-bunner-img2 {
		width: 100%;
		height: 600px !important;
		background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
		background-repeat: no-repeat;
		background-size: contain;
	}
}
.main-bunner-img2 {
	width: 100%;
	height: 800px;
	background-image: url(~@/assets/img/caseDetails/village_resources/index.png);
	background-repeat: no-repeat;
	background-size: contain;
}

.maim-module-01 {
	width: 100%;
	height: 700px;
	background: rgba(255, 255, 255, 1);
	display: flex;
	align-items: center;
}

.maim-module-01-center {
	width: 1200px;
	margin: 0 auto;
}

.maim-module-01-center-text {
	width: 1200px;
	height: 180px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
}

.maim-module-02 {
	width: 100%;
	height: 700px;
	background: #FCF9FC;
	display: flex;
	align-items: center;
}

.maim-module-02-center {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}

.maim-module-02-center-img {
	width: 670px;
	height: 377px;
}

.maim-module-02-center-text {
	width: 460px;
	height: 377px;
	display: flex;
	flex-direction: column;

}

.text-img-box h2 {
	width: 460px;
	height: 45px;
	text-align: right;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(48, 181, 94, 1);
	line-height: 45px;
	margin-top: 25px;
	margin-bottom: 15px;
}

.segmentation {
	width: 460px;
	height: 5px;
	text-align: right;
	margin-top: 5px;
	margin-bottom: 20px;
}

.text02 {
	width: 460px;
	height: 216px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
  line-height: 36px;
  text-align: left;
}

.maim-module-03 {
	width: 100%;
	height: 700px;
	background: #FFFEFF;
	display: flex;
	align-items: center;
}

.img-model {
	width: 670px;
	height: auto;
}

.bottom {
	width: 100%;
	height: 1114px;
	background-image: url(~@/assets/img/caseDetails/intelligentAgricultureall/bj.png);
	background-repeat: no-repeat;
	background-size: auto 100%;
}

.bottom-center {
	width: 1040px;
	margin: 0 auto;
}

h3 {
	width: 1040px;
	height: 45px;
	text-align: center;
	font-size: 32px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: rgba(51, 51, 51, 1);
	line-height: 45px;
	padding-top: 63px;
}

.separation-text {
	margin-top: 25px;
	display: flex;
	justify-content: center;
}

.separation-text-01 {
	width: 127px;
	height: 2px;
	text-align: center;
	background: rgba(51, 51, 51, 1);
	opacity: 0.49770000000000003;
}

.list {
	margin-top: 44px;
  text-align: left;
}

.list-text {
	display: inline-block;
	width: 848px;
	height: 36px;
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(51, 51, 51, 1);
	line-height: 36px;
  margin-left: 20px;
}
.village-resources-box{
    width: 1000px;
    margin: auto;
    padding: 80px 0;
    position: relative;
}
.village-resources-cbox{
    width: 27%;
    float: left;
    height: 360px;
    margin: 3%;
    background: #fff;
    box-shadow: 0 5px 2px #eaeaea;
    padding: 20px;
}
.village-resources-cbox img{
    width: 100px;
    margin: auto;
}
.village-resources-cbox h4{
    line-height: 58px;
	font-size: 18px;
}
.village-resources-cbox p{
    line-height: 40px;
    font-size: 16px;
} 
.left-line{
position: absolute;
    left: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-left: 80px;
    top: 89px;
}

.right-line{
position: absolute;
    right: 50%;
    width: 60px;
    height: 1px;
    background: #C7C7C7;
    margin-right: 80px;
    top: 89px;
}




</style>